import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { RestServiceLinkedService } from 'app/model/linkedservice/rest-service.linkedservice';
import { ParameterConfig } from '../pipeline/parameter-config';
import { Dataset } from 'app/model/dataset/dataset';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.rest.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.RestService_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.RestService_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: RestServiceLinkedService.MODEL
        }
    }
})
export class RestResourceDataset extends Dataset {
    public static readonly MODEL: IModel;
    public static readonly URL: IAttribute;
    public static readonly METHOD: IAttribute;
    public static readonly BODY: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'URL',
        display: stringResources.Dataset_RelativeUrl
    })
    public relativeUrl?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'METHOD',
        display: stringResources.Dataset_RequestMethod
    })
    public requestMethod?: string = 'GET';

    @Metamodel.attribute({
        templatable: true,
        association: 'BODY',
        display: stringResources.Dataset_RequestBody
    })
    public requestBody?: string;

    @Metamodel.attribute({
        display: stringResources.Dataset_AdditionalHeaders,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public additionalHeaders?: ParameterConfig[] = [];

    @Metamodel.attribute({
        display: stringResources.Dataset_PaginationRules,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public paginationRules?: ParameterConfig[] = [];
}
